/* Site-wide acquisition capture for lead forms.
   Load on every page (layout/theme.liquid) so a visitor who lands on a product page
   from an ad and later finds the corporate gifting form still carries the source.
   fws_attr_ft = first touch (set once), fws_attr_lt = last non-direct touch. 90-day first-party cookies. */
(function () {
  if (window.fwsAttribution) return;
  var DAYS = 90;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid'];

  function read(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }
  function write(name, val) {
    var exp = new Date(Date.now() + DAYS * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(val)) + '; expires=' + exp + '; path=/; SameSite=Lax';
  }

  var params = new URLSearchParams(window.location.search);
  var touch = {};
  var tagged = false;
  KEYS.forEach(function (k) {
    var v = params.get(k);
    if (v) { touch[k] = v.slice(0, 150); tagged = true; }
  });

  var ref = document.referrer;
  var refHost = '';
  try { refHost = ref ? new URL(ref).hostname : ''; } catch (e) {}
  var internal = refHost && (refHost === location.hostname || /(^|\.)flatiron-wines\.com$/.test(refHost) || /(^|\.)shopify\.com$/.test(refHost));
  var external = refHost && !internal;

  if (touch.gclid && !touch.utm_source) { touch.utm_source = 'google'; touch.utm_medium = 'cpc'; }
  if (!tagged && external) { touch.utm_source = refHost.replace(/^www\./, ''); touch.utm_medium = 'referral'; }
  var meaningful = tagged || external;

  touch.landing_page = (location.pathname + location.search).slice(0, 300);
  touch.referrer = ref ? ref.slice(0, 300) : '';
  touch.ts = new Date().toISOString();

  if (!read('fws_attr_ft')) {
    if (!meaningful) { touch.utm_source = '(direct)'; touch.utm_medium = '(none)'; }
    write('fws_attr_ft', touch);
  }
  if (meaningful) write('fws_attr_lt', touch);

  window.fwsAttribution = function () {
    return { first_touch: read('fws_attr_ft'), last_touch: read('fws_attr_lt') || read('fws_attr_ft') };
  };
})();
